export type NotificationAction = { action: string; title: string }
export type NotificationActions = {
  token: string
  kind: 'permission' | 'management' | 'interaction'
  actions: NotificationAction[]
}

/** Keep only actions actually supplied by the signed notification delivery. */
export function notificationActions(payload: Record<string, unknown>): NotificationActions | undefined {
  if (!['ai.permission_required', 'ai.interaction_required'].includes(String(payload.event))) return
  const token = payload.action_token ?? payload.scp_action_token
  const kind = payload.action_kind ?? payload.scp_action_kind
  if (typeof token !== 'string' || !/^[A-Za-z0-9_-]{43}$/.test(token)) return
  if (kind !== 'permission' && kind !== 'management' && kind !== 'interaction') return
  let raw = payload.actions ?? payload.scp_actions
  if (typeof raw === 'string') {
    try { raw = JSON.parse(raw) } catch { return }
  }
  if (!Array.isArray(raw)) return
  const seen = new Set<string>()
  const actions: NotificationAction[] = []
  for (const item of raw.slice(0, 3)) {
    if (!item || typeof item.action !== 'string' || typeof item.title !== 'string') continue
    const allowed = kind === 'interaction' ? /^choice_[0-2]$/ : /^(allow|deny|review)$/
    if (!allowed.test(item.action) || !item.title.trim() || seen.has(item.action)) continue
    seen.add(item.action)
    actions.push({ action: item.action, title: item.title.trim().slice(0, 32) })
  }
  if (actions.length) return { token, kind, actions }
}
